import { render, staticRenderFns } from "./LowBalanceAccountsTab.vue?vue&type=template&id=7b07f23d"
import script from "./LowBalanceAccountsTab.vue?vue&type=script&lang=js"
export * from "./LowBalanceAccountsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports